import { render } from "./HomeImprovement.vue?vue&type=template&id=447d8f88"
import script from "./HomeImprovement.vue?vue&type=script&lang=js"
export * from "./HomeImprovement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__